export const GetDistance = (lat1, lon1, lat2, lon2) => {
    if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist;
    }
};

export const GetTripDistance = async (data) => {
    if (data) {
        const arr = Object.keys(data)
            .filter(function (i) {
                return data[i].status == 'STARTED' || data[i].status == 'REACHED'
            })
            .map(i => {
                data[i].id = i
                return data[i]
            });
        let distance = 0;
        let coords = [];
        try{
            if (arr.length == 0 || arr.length == 1) {
                distance = 0;
            } else if (arr.length == 2) {
                distance = GetDistance(arr[0].lat, arr[0].lng, arr[1].lat, arr[1].lng);
                coords.push({latitude : arr[0].lat, longitude : arr[0].lng});
                coords.push({latitude : arr[1].lat, longitude : arr[1].lng});
            } else {
                for (let i = 0; i < (arr.length - 1); i++) {
                    distance = distance + GetDistance(arr[i].lat, arr[i].lng, arr[i + 1].lat, arr[i + 1].lng)
                    coords.push({latitude : arr[i].lat, longitude : arr[i].lng});
                }
                coords.push({latitude : arr[arr.length - 1].lat, longitude : arr[arr.length - 1].lng});
            }
        }catch(error){
            console.log(error);
        }
        return {
            distance:distance ,
            coords: coords
        };
    }
    else {
        return {
            distance:0,
            coords:[]
        };
    }
}

// Driver positions (locations/<uid>) older than this are ignored when a booking is dispatched (web
// booking page, mobile customer app and the server's bookingScheduler). The driver app re-saves its
// position at least every DRIVER_LOCATION_HEARTBEAT_MS while it is alive, so a stale stamp means the
// app was killed while the driver was still marked online. Positions without `at` were written by an
// app version before the stamp existed; the scheduler stamps them within a minute, so they count as
// fresh until then. Keep identical to driverLocationIsFresh in functions/common/sharedFunctions.js.
export const DRIVER_LOCATION_STALE_MS = 10 * 60 * 1000;
export const DRIVER_LOCATION_HEARTBEAT_MS = 60 * 1000;
// The foreground heartbeat stops re-stamping a GPS fix older than this: the app is alive but its position is unknown.
export const DRIVER_FIX_MAX_AGE_MS = 15 * 60 * 1000;
export const driverLocationIsFresh = (location, now) => {
    if (!location) {
        return false;
    }
    if (location.at === undefined || location.at === null) {
        return true;
    }
    const at = Number(location.at);
    return isFinite(at) && now - at <= DRIVER_LOCATION_STALE_MS;
};

// settings.driverRadius, in km (miles when convert_to_mile), 10 when unset. Same default as the scheduler.
export const dispatchRadius = (settings) => (settings && settings.driverRadius ? settings.driverRadius : 10);

// Picks the drivers to request for a booking. `drivers` are the eligible driver records (uid or id,
// carType, fleetadmin); `locations` is a fresh read of locations/ and `now` the server time it was read
// at (api.fetchDriverLocations), never the position cached on the driver record. A driver is picked when
// the position is fresh, has numeric coordinates, lies inside dispatchRadius of the pickup and passes the
// caller's accept(driver) test (car type, fleet). Returns { [uid]: { distance, timein_text } }, the
// driverEstimates shape.
export const selectDispatchDrivers = (drivers, locations, pickup, settings, now, accept) => {
    const picked = {};
    if (!pickup || !locations) {
        return picked;
    }
    const radius = dispatchRadius(settings);
    (drivers || []).forEach((driver) => {
        const uid = driver ? (driver.uid || driver.id) : null;
        const location = uid ? locations[uid] : null;
        if (!driverLocationIsFresh(location, now)) {
            return;
        }
        const lat = Number(location.lat), lng = Number(location.lng);
        if (!isFinite(lat) || !isFinite(lng)) {
            return;
        }
        let distance = GetDistance(Number(pickup.lat), Number(pickup.lng), lat, lng);
        if (settings && settings.convert_to_mile) {
            distance = distance / 1.609344;
        }
        if (distance < radius && (!accept || accept(driver))) {
            picked[uid] = { distance: distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min' };
        }
    });
    return picked;
};